// @ts-nocheck
import React, { useState, useEffect } from "react";
import { Blurhash } from "react-blurhash";
import { useWindowWidth } from "./helpers/windowWidth";

interface ImageProps {
  src: string;
  className?: string;
  hash: string;
}

const BlurImage: React.FC<ImageProps> = ({ src, className, hash }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setImageLoaded(true);
    };
    img.src = src;
  }, [src]);
  return (
    <>
      {!imageLoaded && (
        <>
          <Blurhash
            width={"100%"}
            hash={hash}
            resoltionX={32}
            resolutionY={32}
            punch={1}
            className="blurHashImage"
          />
        </>
      )}
      {imageLoaded && (
        <img src={src} alt="" className={className ? className : ""}></img>
      )}
    </>
  );
};

export default BlurImage;
